import { api } from "../App";

export const getPeriods = () => api.get(`/courses`);

export const getCourses = (yearId = 14) => {
  return api.get(`/courses/structure?year=${yearId}`);
};

export const getScheme = (courseId) => {
  return api.get(`/courses/${courseId}/schemes/`);
};

export const getSchemePDF = (courseId) => {
  return api.get(`/courses/${courseId}/schemes/pdf`);
};

export const generateScheme = (courseId, data) => {
  return api.put(`/courses/${courseId}/schemes/generate`, data);
};

export const fetchSchemeStatus = (courseId) => {
  return api.get(`/courses/${courseId}/schemes/generate`);
};

export const regenerateScheme = (courseId, data) => {
  const { type } = data;
  return api.post(`/courses/${courseId}/schemes/generate${type != null ? `/image` : ""}`, data);
};

export const saveScheme = ({ data, schemeId }) => {
  return api.put(`/courses/${schemeId}/schemes/`, { data });
};
